import { render } from "./SummaryCard.vue?vue&type=template&id=71a98c3a&scoped=true"
import script from "./SummaryCard.vue?vue&type=script&lang=js"
export * from "./SummaryCard.vue?vue&type=script&lang=js"

import "./SummaryCard.vue?vue&type=style&index=0&id=71a98c3a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a98c3a"]])

export default __exports__